import mixpanel from 'mixpanel-browser';

let initialized = false;

export const mixpanelProvider = {
  init(apiKey) {
    if (!apiKey) { console.warn('[Analytics] Mixpanel key missing'); return; }
    mixpanel.init(apiKey, {
      record_sessions_percent: 100,
      api_host: 'https://api-eu.mixpanel.com',
    });
    initialized = true;
  },

  track(name, data) {
    if (!initialized) return;
    mixpanel.track(name, data);
  },

  identify(id, traits) {
    if (!initialized) return;
    mixpanel.identify(id);
    if (traits && Object.keys(traits).length) {
      mixpanel.people.set(traits);
    }
  },

  isReady: () => initialized,
};
